import { render, staticRenderFns } from "./AcclaimBadge.vue?vue&type=template&id=04cf1ba2&scoped=true"
import script from "./AcclaimBadge.vue?vue&type=script&lang=js"
export * from "./AcclaimBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cf1ba2",
  null
  
)

export default component.exports